import { render, staticRenderFns } from "./NivelMedio.vue?vue&type=template&id=27947f2a&scoped=true"
import script from "./NivelMedio.vue?vue&type=script&lang=js"
export * from "./NivelMedio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27947f2a",
  null
  
)

export default component.exports